import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import { OptionsContainer, CrossButton } from '../../../funds/common/dropdown/styles';
import Header from '../../../shared/modal/header';
import InvestModalBody from './invest-modal-components/invest-modal-body';
import Contact from './invest-modal-components/invest-contact';
import dt, { useIsMobile } from '../../../../shared/theme';
import { PopUpModalStyles } from '../../../shared/modal/styles';
import useFundStateStore from '../../common/fund-state-hook';

const SOptionsContainer = styled(OptionsContainer)`
  z-index: 210;
  padding: 112px 0 0 0;

  > div.first-of-type {
    position: fixed;
  }

  > div.contact {
    display: flex;
    flex-direction: column;
    align-items: center;

    > button {
      text-transform: none;
      font-size: 19px;
      max-width: 285px;
    } 

    > p.external-link {
      font-size: 17px;
      font-weight: 700;
      text-align: center;
      height: 20px;
      margin: 12px 0 40px;
  
      span.icon-lw-external-link {
        font-size: 14px;
        margin-right: 6px;
      }
    }
  }
`;

const PopUpModal = styled(Modal)`
  ${PopUpModalStyles};
  padding: 0 16px;

  article.horizontal {
    width: unset;
    max-width: 1200px;
    max-height: 100vh;

    ${props => dt(props).theme.isMobile && `
      margin: 0;
      border-radius: 0;
      overflow-y: auto;

      > div {
        > button.close {
          color: ${dt(props).theme.bodyColor};
          height: 21px;
          position: relative;
          top: 68px;
          right: 20px;
        }
      }
    `}
  }
`;

export default function InvestModal({ fund, contact }) {
  const set = useFundStateStore(state => state.set);
  const show = useFundStateStore(state => state.showInvestModal);
  const isMobile = useIsMobile();

  const handleHide = () => {
    set(state => {
      state.showInvestModal = false;
    });
  };

  return (
    <>
      {!isMobile
        && (
        <PopUpModal
          show={show}
          centered="true"
          dialogAs="article"
          dialogClassName="horizontal"
          onHide={handleHide}
          className={show ? 'show' : 'hide'}
        >
          <Header closeButton />
          <InvestModalBody fund={fund} contact={contact} />
        </PopUpModal>
        )}
      {!!isMobile && (
      <>
        <SOptionsContainer className={show ? 'slide-up' : 'slide-down'}>
          <CrossButton onClick={handleHide}>&#10005;</CrossButton>
          <InvestModalBody fund={fund} />
          <Contact id={fund.id} url={fund.fundPageUrl} contact={contact} />
        </SOptionsContainer>
      </>
      )}
    </>
  );
}

InvestModal.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isin: PropTypes.string.isRequired,
    stockCode: PropTypes.string,
    fundPageUrl: PropTypes.string,
  }).isRequired,
  contact: PropTypes.func.isRequired,
};
